import _filter from 'lodash/filter';
import memoizeOne from 'memoize-one';

import { findContentByType } from '@/components/EditorBuilder/utils';
import { Blocks } from '@/components/PageEditor/types';
import { CoursePerformanceFragment } from '@/modules/corporate/modules/course/graphql/fragments/generated/CoursePerformance';

import { ContentType, SidebarContentType } from '../views/CourseBuilder/components/Sidebar/types';
export { findContentByType } from '@/components/EditorBuilder/utils';

export const getLessonPageId = (lessonContent?: ContentType) =>
  findContentByType(lessonContent?.content, Blocks.REF)?.attrs?.refId;

export const getBlockId = (block?: ContentType) => block?.attrs?.id;

export function findAllContentByType(content?: ContentType[], type?: Blocks) {
  return _filter(content, { type });
}

const getAdaptedLesson = (
  block: ContentType,
  contentPerformance?: Record<string, CoursePerformanceFragment>,
) => {
  const titleContent = findContentByType(block.content, Blocks.TITLE)?.content;
  const title = findContentByType(titleContent, Blocks.TEXT)?.text;
  const lessonId = getBlockId(block);

  return {
    id: getLessonPageId(block)!,
    blockId: lessonId,
    label: title ?? '',
    isOptional: block.attrs?.isOptional,
    content: {
      progress: contentPerformance?.[lessonId!]?.progress,
      duration: block.attrs?.duration ?? 0,
    },
  };
};

export const adaptedSidebarContent = (
  content?: ContentType,
  contentPerformance?: Record<string, CoursePerformanceFragment>,
): SidebarContentType[] => {
  const lessons = findAllContentByType(content?.content, Blocks.LESSON);

  return (
    lessons
      ?.map((lesson, index) => {
        // get sub lessons for a lesson
        const subLessons = findAllContentByType(lesson.content, Blocks.LESSON);

        // get course lessons title + perf
        const adaptedSubLessons = subLessons.map((subLesson) => ({
          ...getAdaptedLesson(subLesson, contentPerformance),
          lessonPageId: getLessonPageId(lesson)!,
          sectionIndex: index,
        }));

        return {
          ...getAdaptedLesson(lesson, contentPerformance),
          items: adaptedSubLessons,
        };
      })
      ?.filter((v) => v) ?? []
  );
};

export const getAdaptedSidebarContent = memoizeOne(adaptedSidebarContent);
